module.exports = __webpack_public_path__ + "images/092a5b6f3b6fa12fb0107b47fff37c1a.svg";